import { inject, observer } from 'mobx-react';
import React from 'react'
@inject('viewStore', 'store') @observer
class SharedView extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      ctaOpen: false
    }
  }

  async componentDidMount(){
    this.props.viewStore.setDesignId()
  }

  render(){
    const { designHTML } = this.props.viewStore
    return (
      designHTML ? (
        <div>
          <div className={`shared-view-wrapper ${this.props.store.auth ? 'auth' : 'unauth'}`} dangerouslySetInnerHTML={{__html: designHTML}} />
        </div>
      )
      :
      <div />
    )
  }
}

export default SharedView